<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <b-card no-body class="invoice-preview-card px-2" id="invoice-preview-card" style="display: block; width: 100%">
          <b-card-body class="">
            <div class="row align-items-center mb-2">
              <div class="col-md-1 col-1" >
                <Logo />
              </div>
              <div class="col-9">
                <div class="">
                  <CompanyName />
                </div>
                <div class="">
                  <Address />
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                <h4 class="mb-1">Customer</h4>

               <ClientAddress  :client="whenSelected" />
                
              </div>

              <div class="col-12 col-lg-6 text-left text-lg-right mt-3 mt-lg-0">
                <!-- {{ quotationId.priority }} -->
                <!-- Header: Right Content -->
                <h4>
                  Quotation
                  <span class="invoice-number">#{{ quotationId.quotationNo }}</span>
                </h4>

                <div class="text-left text-lg-right">
                  <div class="row invoice-date-wrapper justify-content-lg-end mb-2">
                    <div class="col-12 col-lg-6 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0">
                      <span class="title"> Date: </span>
                    </div>
                    <div class="col-12 col-lg-6 d-flex justify-content-lg-end" >
                      <flat-pickr v-model="quotationId.createdOn" class="form-control invoice-edit-input w-100" disabled />
                    </div>
                  </div>

                  <div class="row invoice-date-wrapper mb-2">
                    <div class="col-12 col-lg-7 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0">
                      <span class="title"> Due Date: </span>
                    </div>
                    <div class="col-12 col-lg-5 d-flex justify-content-lg-end">
                      <flat-pickr v-model="quotationId.dueDate" class="form-control invoice-edit-input w-100" disabled />
                    </div>
                  </div>
                  <!-- <div class="row invoice-date-wrapper">
                    <div class="col-md-7 col-5 d-flex justify-content-md-end">
                      <span class="title"> Priority </span>
                    </div>
                    <div class="col-md-5 col-7 d-flex justify-content-md-end">
                      <b-form-select :options="optionPriority" v-model="quotationId.priority" />
                    </div>
                  </div> -->

                  <div class="row invoice-date-wrapper mb-2" v-if="this.vat"
                  >
                    <div class="col-12 col-lg-7 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0">
                      <p class="invoice-date-title">VAT:</p>
                    </div>
                    <div class="col-12 col-lg-5 d-flex justify-content-lg-end">
                      <p class="invoice-date">
                        {{ this.vat }}
                      </p>
                    </div>
                  </div>

                  <div class="row invoice-date-wrapper mb-2" v-if="this.vat"
                  >
                    <div class="col-12 col-lg-7 d-flex justify-content-between justify-content-lg-end mb-2 mb-lg-0">
                      <p class="invoice-date-title">BRN Number:</p>
                    </div>
                    <div class="col-12 col-lg-5 d-flex justify-content-lg-end">
                      <p class="invoice-date">
                        {{ this.brn }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-card-body>
            <div class="table-responsive-wrapper">
              <b-table responsive bordered :fields="dynamicFields" :items="quotationId.quotationItems" class="mb-0">

              <template #cell(productImg)="data">
                <template v-if="data.item.itemId">
                  <img
                    :src="`${baseUrl}selfservices/getproductimage?ProductID=${data.item.itemId}`"
                    alt="Product Image" class="product-image"
                    @error="showNoImage($event)" />
                </template>
                <template v-else>
                  <span>-</span>
                </template>
              </template>

              <template #cell(cost)="data">
                {{ currencySymbol }}
                {{ parseFloat(data.item.cost).toFixed(2) }}
              </template>

              <template #cell(qty)="data">
                {{ parseFloat(data.item.quantity).toFixed(5) }}
              </template>

              <template #cell(VAT)="data" >
                {{  data.item.tax ? parseFloat(data.item.tax).toFixed(2) : 0 }} %
              </template>

              <!-- <template #cell(cost)="data">
                {{ currencySymbol }}
                {{
                  (
                    data.item.cost * data.item.quantity -
                    (data.item.discount === null ? 0 : data.item.discount)
                  ).toFixed(2)
                }}
              </template> -->
              <template #cell(discount)="data">
                {{
                  (data.item.discount === null
                    ? 0
                    : data.item.discount
                  ).toFixed(2)
                }}
              </template>
            </b-table>
            </div>
          </b-card-body>
          <!-- Invoice Description: Total -->
          <b-card-body class="" v-if="HasPermission(PermissionList.Sales_Finance)">
            <b-row>
              <!-- Col: Sales Persion -->
              <b-col cols="12" md="6" class="mt-md-0 mt-3" order="2" order-md="1">
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">Salesperson :</span>
                  <span class="ml-75">{{ this.genSP }} </span>
                </b-card-text>
              </b-col>

              <!-- Col: Total -->
              <b-col cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Subtotal:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }} {{ parseFloat(quotationId.subTotal).toFixed(2) }}
                    </p>
                  </div>
                  <div class="invoice-total-item" v-if="quotationId.discount > 0">
                    <p class="invoice-total-title">Discount</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }} {{ parseFloat(quotationId.discount).toFixed(2) }}
                    </p>
                  </div>
                  <div class="invoice-total-item" v-if="vat">
                    <p class="invoice-total-title">VAT</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }} {{ parseFloat(quotationId.tax).toFixed(2) }}
                    </p>
                  </div>

                  <hr class="my-50" />
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Total:</p>
                    <p class="invoice-total-amount">
                      {{ currencySymbol }} {{ parseFloat(quotationId.total).toFixed(2) }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0 px-0">
            <span class="font-weight-bold">Note: </span>
            <span>{{ quotationId.notes }}</span>
          </b-card-body>

          <div class="row"></div>

          <div class="row mt-3 signature-section">
            <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0">
              <h4 class="text-center">Received By:</h4>
              <p class="text-center"></p>
              <p class="text-center signature-line"></p>
              <p class="text-center"></p>
              <p class="text-center"></p>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0">
              <h4 class="text-center">Sent By:</h4>
              <p class="text-center"></p>
              <p class="text-center signature-line"></p>
              <p class="text-center"></p>
              <p class="text-center"></p>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-sm-0">
              <h4 class="text-center">Delivered By:</h4>
              <p class="text-center"></p>
              <p class="text-center signature-line"></p>
              <p class="text-center"></p>
              <p class="text-center"></p>
            </div>
          </div>
        </b-card>

        
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <!-- Button: DOwnload -->

          <!-- Button: Print -->
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" class="mb-75" block
            @click="printQuotation">
            Print / Download
          </b-button>


          <b-button class="mb-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" block
            @click="handleDocBtn(quotationId.id)">
            <b-spinner small v-if="loading"> </b-spinner>
            Documents
          </b-button>

          <b-col md="3" class="d-flex justify-content-end">
            <b-modal ref="modal-view-quote-document" id="modal-view-quote-document" ok-only ok-title="View" centered
              size="lg" title="View Quote Documents" :hide-footer="true">
              <DocumentUpload @deleteFile="deleteFile" @downloadFile="downloadFile" @uploadFiles="uploadFiles"
                :documentDetails="documentDetails" />
            </b-modal>
          </b-col>

          <b-button v-if="whenSelected.tel && tenant" v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="info"
            class="mb-75" @click="openWhatsApp" block>
            <img src="@/assets/images/logo/whatsapp.png" class="w-10" />
            Whatsapp
          </b-button>

          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="primary" class="mb-75" block
            v-if="quotationId.status != 3" @click="convertProforma">
            Convert to Proforma
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modal-addWarehouse" v-model="showAddWarehouseModal" @hide="onModalHide" centered>
      <span for="invoice-data-sales-person" class="text-nowrap mr-50">Choose Warehouse:</span>
      <b-form-select v-model="warehouseId" :options="optionsWarehouse" />
      <template #modal-footer>
        <b-button @click="continueConvertProforma">Okay</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BLink,
  BFormSelect,
  BSpinner,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import html2pdf from "html2pdf.js";
import api from "@/api/api-v2-config";
import { mapActions, mapGetters } from "vuex";
import { CurrencySymbols } from "@/libs/defaultList";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';

import {
  deleteQuotationDocument,
  uploadQuotationMultipleDocuments,
  uploadQuotationDocument,
  downloadQuotationDocument,
} from "@/store/quotation/services";
import {
  customSwal,
  customError,
  customLoader,
  fnSortingDropdown,
} from "@/libs/customFn";
import ClientAddress from "@/@core/layouts/components/ClientAddress.vue";


export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
    Ripple,
  },
  components: {
    flatPickr,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    VBToggle,
    BFormSelect,
    Logo,
    Address,
    CompanyName,
    BSpinner,
    BTable,
    BLink,
    BModal,
    DocumentUpload,
    ClientAddress
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      id: this.$route.params.id,
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      brn: JSON.parse(localStorage.getItem("userData")).brn,
      tenant: localStorage.getItem("userTenant"),
      companyName: localStorage.getItem("userTenant"),
      genSP: "",
      leadClientId: "",
      salesPersonId: "",
      dueDate: "",
      subTotal: "",
      discount: "",
      tax: "",
      total: "",
      notes: "",
      status: "",
      whenSelected: [],
      paymentMethod: "",
      priority: "",
      optionPriority: [
        { value: "LOW", text: "LOW" },
        { value: "MEDIUM", text: "MEDIUM" },
        { value: "HIGH", text: "HIGH" }
      ],
      quotationItems: {
        id: "",
        quotationId: "",
        itemId: "",
        quantity: "",
        price: "",
        cost: "",
        isActive: "",
      },
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      warehouseId: "",
      currencySymbol: "Rs",
      optionsWarehouse: [],
      baseUrl: process.env.VUE_APP_MAIN_URL,
      fields: [
        {
          key: "productImg",
          label: "Product",
          formatter: (value, key, item) => {
            if (item.itemId) {

              // Directly set the image src to the API endpoint
              let src = `${baseUrl}selfservices/getproductimage?ProductID=${item.itemId}`;
              console.log("src", src);
              return src;
            }

          },
        },

        { key: "id", span: "ID", thClass: "d-none", tdClass: "d-none" }, //thClass and tdClass used to hide fields
        {
          key: "quotationId",
          span: "QUOTATION_ID",
          thClass: "d-none",
          tdClass: "d-none",
        },
        { key: "itemName", label: "Item Name", span: "Item Name" },
        { key: "description", label: "Description", span: "DESCRIPTION" },
        { key: "cost", label: "Unit Price ", span: "Unit Price" },
        { key: "quantity", label: "Quantity", span: "QUANTITY" },
        // { key: "discount", label: "Discount (Rs)", span: "DISCOUNT" },
        { key: "price", label: "Total ", span: "Total Price " },
      ],
      showAddWarehouseModal: false,
      continueConversion: false,
    };
  },
  computed: {

    getUserName(){
      const name = this.usersId.firstName + " " + this.usersId.lastName;
      return name;
    },


    dynamicFields() {
  let baseFields = [
    {
      key: "itemName",
      label: "Product Name",
      formatter: (value, key, item) => {
        if (item.invoiceType === "Service") {
          let serviceOrder = this.serviceOrderList.find(
            (x) => x.id == item.serviceOrderId
          );
          return serviceOrder
            ? `${serviceOrder.orderTemplateName} - ${serviceOrder.serviceReferenceNo}`
            : "";
        } else {
          return item.itemName;
        }
      },
    },
    {
      key: "description",
      label: "Description",
      formatter: (value, key, item) => {
        if (item.invoiceType === "Service") {
          let serviceOrder = this.serviceOrderList.find(
            (x) => x.id == item.serviceOrderId
          );
          return serviceOrder ? serviceOrder.orderTemplateName : "";
        } else {
          return item.description;
        }
      },
    },
    { key: "quantity", label: "Qty" },
  ];

  // Conditionally add VAT column
  if (this.vat && !this.hideVAT) {
    baseFields.push({
      key: "vat",
      label: "VAT",
      formatter: (value, key, item) => {
        return item.tax ? `${item.tax} %` : "0 %";
      },
    });
  }

  // ✅ Conditionally add Unit Price and Total Price based on permission
  if (this.HasPermission(this.PermissionList.Sales_Finance)) {
    baseFields.push({
      key: "price",
      label: "Unit Price",
      formatter: (value, key, item) =>
        `${this.currencySymbol} ${item.cost.toFixed(2)}`,
    });

    baseFields.push({
      key: "totalPrice",
      label: "Total Price",
      formatter: (value, key, item) => {
        const total = (item.cost || 0) * (item.quantity || 0);
        return `${this.currencySymbol} ${total.toFixed(2)}`;
      },
    });
  }
  else{

  }

  // Optional: Conditionally add product image
  if (this.isFieldChosen("ProductImage")) {
    baseFields.unshift({
      key: "productImg",
      label: "Product",
      formatter: (value, key, item) => {
        if (item.invoiceType === "Service") {
          return "";
        } else if (item.itemId) {
          return `${this.baseUrl}selfservices/getproductimage?ProductID=${item.itemId}`;
        }
        return "";
      },
    });
  }

  return baseFields;
},
    ...mapGetters("tenantModule", {
      tenantFields: "tenantFields",
    }),

    ...mapGetters("userModule", {
      usersId: "usersId",
      loading: "loading",
    }),

    ...mapGetters("quotationModule", {
      quotationId: "quotationId",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
    ...mapGetters("customerModule", {
      custId: "custId",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("leadModule", {
      leadList: "leads",
      leadId: "leadId",
      loadingCustomer: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
  },
  methods: {
    showNoImage(event) {
      // If the image fails to load, replace it with text "No Image"
      const parentElement = event.target.parentNode;
      if (parentElement) {
        parentElement.innerHTML = '<span>-</span>';
      }
    },
    isFieldChosen(key) {
      const result = this.chosenFields.some((field) => field.key === key);
      return result;
    },
    ...mapActions("tenantModule", [
      "getTenantFCByModuleAction",
      "updateTenantFCAction",
    ]),


    printQuotation() {
      window.print();
    },
    ...mapActions("customerModule", ["getCustomersByIDAction"]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("quotationModule", ["getQuotationByIdAction", "getQuotationDocumentListAction",]),
    ...mapActions("leadModule", ["getLeadListAction", "getLeadByIDAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    ...mapActions("userModule", ["getUserIdAction"]),
    beautifyDate(dateString) {
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },
    async handleDocBtn(referenceId) {
      try {
        await this.getQuotationDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-quote-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },
    success(response) {
      console.log(response.data);
      this.$swal({
        title: "Quote converted!",
        text: "Quote Converted to Proforma Successfully!",
        icon: "success",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(() => {
        this.$router.push("/proforma/view/" + response.data.result.id);
      });
    },
    error(error) {
      this.$swal({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
    },

    async convertProforma() {
      console.log("warehouse", this.warehouseId);
      if (this.warehouseId === "") {
        this.$bvModal.show("modal-addWarehouse");
       // this.showAddWarehouseModal = true;
      } else if (this.continueConversion) {
        this.continueConversion = false;
        this.$swal({
          title: "Loading...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            this.$swal.showLoading();
          },
        });
        await api
          .post("quotes/convertion", {
            id: this.id,
            warehouseId: this.warehouseId,
          })
          .then((response) => {
            this.$swal.close();
            console.log(response.data);
            this.success(response);
          })
          .catch((error) => {
            this.$swal.close();
            this.error(error);
          });
      }
    },
    onModalHide() {
      this.continueConversion = false;
    },
    continueConvertProforma() {
      this.showAddWarehouseModal = false;
      this.continueConversion = true;
      this.convertProforma();
    },

    openWhatsApp() {
      const message = `Please find attached the quote for the recent transaction with ${this.companyName}. ${process.env.VUE_APP_CRM_URL}quote/${this.tenant}/${this.id}`;
      const url = `https://web.whatsapp.com/send/?phone=${this.whenSelected.tel}&text=${message}&type=phone_number`;
      window.open(url, "_blank");
    },

    async downloadFile(downloadById, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadQuotationDocument(downloadById);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.quotationId.id;

      const maxSize = 20 * 1024 * 1024;
        if (this.selectedFiles && this.selectedFiles.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

      if (selectedFiles.length > 1) {
        await uploadQuotationMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
          await this.getQuotationDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      } else if (selectedFiles.length < 2) {
        await uploadQuotationDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });

          await this.getQuotationDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.handleDocBtn(referenceId);
      this.$nextTick(() => {
        this.$bvModal.show("modal-view-quote-document");
      });
      }
    },

    async deleteFile(deleteById) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteQuotationDocument(deleteById)
        .then((response) => {
          loader.close();
          customSwal("File deleted successfully!");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getQuotationDocumentListAction(this.quotationId.id);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-quote-document");
      });
    },

    downloadPDF() {
      var opt = {
        margin: [0, 0],
        filename: "quotation.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2, allowTaint: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      var element = document.getElementById("invoice-preview-card");
      var elementHtml = element.outerHTML;
      html2pdf().from(elementHtml).set(opt).save();
    },
  },
  beforeMount() {
    this.getWarehouseListAction();
    this.getSalesPersonListAction();
  },
  async mounted() {

  this.whenSelected = null;
    await this.getTenantFCByModuleAction("SalesInvoice").then(() => {
      // Assign the fields after the action is complete
      this.chosenFields = this.tenantFields.selectedFieldConfig;
      console.log("Chosen Fields:", this.chosenFields);
    });
    console.log('Is "ProductImage" field chosen:', this.isFieldChosen("ProductImage"));


    if (this.warehouse == undefined || this.warehouse.length == 0)
      await this.getWarehouseListAction();
    if (this.SalesPersonList == undefined || this.SalesPersonList.length == 0)
      await this.getSalesPersonListAction();

    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );
    await this.getQuotationByIdAction(this.id)
      .then(() => {
        this.priority = this.quotationId.priority;
        // this.getLeadByIDAction(this.quotationId.leadClientId)
        //   .then((response) => {
        //     this.whenSelected = this.leadId;

        //   })
        //   .catch((error) => {
        //     this.getCustomersByIDAction(this.quotationId.leadClientId).then(
        //       (response) => {
        //         this.whenSelected = this.custId;
        //       }
        //     );
        //   });

        this.getUserIdAction(this.quotationId.createdBy);
        this.getCustomersByIDAction(this.quotationId.leadClientId)
          .then((response) => {
            //console.log("leadd", this.custId);
            if(this.custId.profile.city != null ){
              //console.log("sdfsdfsdfsf");
              this.custId.city = this.custId.profile.city.name;
            }
            else{
              //console.log("asssssssssssssssssssssssssss");
              this.custId.city = "";
            }
            //console.log("city", this.whenSelected.city);
            this.whenSelected = this.custId;
          })
          .catch((error) => {
            //console.log("leadddddddd");
            this.getLeadByIDAction(this.quotationId.leadClientId).then(
              (response) => {
                
                this.whenSelected = this.leadId;
              }
            );
          });

          this.SalesPersonList.forEach((element) => {
            if (element.id == this.quotationId.salesPersonId) {
              this.genSP = element.firstName + " " + element.lastName;
            }
          });
        this.currencySymbol = CurrencySymbols[this.quotationId.currency];
      })
      .catch((response) => {
        console.log(response);
      });
  },
  setup(props){
    return{
      PermissionList,
      HasPermission
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@media print {
  a[href]:after {
    content: none !important;
  }

  html,
  body {
    height: 99% !important;
  }

  // Global Styles
  .invoice-date-title {
    color: black !important;
  }

  * {
    color: black !important;
  }

  body {
    background-color: transparent !important;
    font-size: 17.5px !important;
    color: black !important;
  }

  nav.header-navbar {
    display: none;
  }

  .flatpickr-input {
    font-size: 17.5px !important;
    color: black !important;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  .content-header {
    display: none !important;
  }

  .invoice-edit-input {
    border: none;
  }

  // Invoice Specific Styles
  .invoice-add-wrapper {
    .row.invoice-add {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            >.col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}

@media print {
  .form-control {
    border: 0;
    width: unset;
    padding: 0;
    text-align: right;
  }
}

/* Mobile Responsiveness Styles */
.product-image {
  width: 75px;
  height: 75px;
  object-fit: cover;
  max-width: 100%;
  height: auto;
}

.signature-line {
  border-bottom: 1px solid black;
  width: 100%;
  max-width: 200px;
  margin: 0.5rem auto;
}

.signature-section {
  margin-top: 1.5rem;
  
  @media (max-width: 576px) {
    .col-12 {
      margin-bottom: 2rem;
    }
  }
}

.table-responsive-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0.25rem;
}

.invoice-date-wrapper {
  margin-bottom: 0.5rem;
  
  @media (max-width: 991px) {
    .col-12 {
      margin-bottom: 0.5rem;
      
      &:first-child {
        p, span {
          margin-bottom: 0;
        }
      }
    }
  }
}

.invoice-total-wrapper {
  @media (max-width: 768px) {
    width: 100%;
  }
}

/* Ensure proper responsiveness for mobile */
@media (max-width: 768px) {
  .invoice-preview-card {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
  
  .invoice-actions {
    margin-top: 1rem;
  }
  
  .invoice-date-wrapper {
    .col-12 {
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
    }
  }
}

@media (max-width: 576px) {
  .invoice-add-wrapper {
    .invoice-number {
      display: block;
      margin-top: 0.5rem;
    }
  }
  
  h4 {
    font-size: 1rem;
  }
  
  .invoice-total-title,
  .invoice-date-title {
    font-size: 0.875rem;
  }
  
  .row.align-items-center {
    align-items: flex-start !important;
  }
}
</style>
